/* eslint-disable import/order */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import CustomerActions from '@Actions/customerActions';
import { H3_TITLE } from '@Apis/constants';
import CustomerOverview from './CustomerOverview';
import CustomerSalesOrder from './CustomerSalesOrder';
import CustomerInvoices from './CustomerInvoices';
import CustomerCreditNotes from './CustomerCreditNotes';
import Helpers from '@Apis/helpers';
import './style.scss';
import CustomerSalesLedger from './CustomerSalesLedger';
import CustomerAccountStatement from './CustomerAccountStatement';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import HideComponent from '../../../Common/RestrictedAccess/HideComponent';

const { TabPane } = Tabs;

/**
 *
 */
class ViewCustomer extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentTab: '/customer-overview',
      documentUINames: {},
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      match, getCustomerById, user,
    } = this.props;
    const { customerId } = match.params;
    getCustomerById(customerId, user?.tenant_info?.tenant_id);

    this.setState({
      documentUINames: documentUINamesConstant(user),
    });
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    const { location } = props;
    const key = new URLSearchParams(location.search).get('tab');
    return {
      ...state,
      currentTab: key || '/customer-overview',
    };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      getCustomerByIdLoading, selectedCustomer, user, history, getCustomerById, match, priceMasking,
    } = this.props;
    const { currentTab, documentUINames } = this.state;
    const { customerId } = match.params;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <div className="view-customer__wrapper">
          <div className="view-customer__details">
            { !getCustomerByIdLoading
              ? (
                <Fragment>
                  <div className="org-customers__add-wrapper-header-left">
                    <div>
                      <div className="org-customers__add-wrapper-header-right-text-title">
                        {`${selectedCustomer?.customer_info?.internal_cust_code} - ${selectedCustomer?.customer_info?.customer_name}`}
                      </div>
                    </div>
                  </div>
                </Fragment>
              )
              : (
                <div className="org-customers__details-loader-wrapper">
                  <div className="loadingBlock org-customers__details-loader-title" />
                </div>
              )}
          </div>
          <Tabs
            activeKey={currentTab.toString()}
            onChange={(key) => {
              history.push(`?tab=${key}`);
              this.setState({ currentTab: key });
            }}
            mode="horizontal"
          >
            <TabPane tab="Overview" key="/customer-overview" />
            {Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user)
                && <TabPane tab={`${documentUINames.salesOrderUIName || 'Sales Order'}s`} key="/customer-sales-orders" />}
            {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ, user)
                && <TabPane tab="Invoices" key="/customer-invoices" />}
            {Helpers.getPermission(Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ, user)
                && <TabPane tab="Credit Notes" key="/customer-credit-notes" />}
            { <TabPane tab="Sales Ledger" key="/customer-sales-ledger" />}
            { <TabPane tab="Statement" key="/customer-statement" />}
          </Tabs>
          {currentTab === '/customer-overview' && (
            <CustomerOverview
              callback={() => {
                getCustomerById(customerId, user?.tenant_info?.tenant_id);
              }}
            />
          )}
          {currentTab === '/customer-sales-orders' && Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER,
            Helpers.permissionTypes.READ, user) && <CustomerSalesOrder />}
          {currentTab === '/customer-invoices' && Helpers.getPermission(Helpers.permissionEntities.INVOICE,
            Helpers.permissionTypes.READ, user) && <CustomerInvoices />}
          {currentTab === '/customer-credit-notes' && Helpers.getPermission(Helpers.permissionEntities.CREDIT_NOTE,
            Helpers.permissionTypes.READ, user) && <CustomerCreditNotes />}
          {currentTab === '/customer-sales-ledger' && ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideComponent />
            : (
              <CustomerSalesLedger
                selectedCustomer={selectedCustomer}
              />
            )
          )}
          {currentTab === '/customer-statement' && ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideComponent />
            : (
              <CustomerAccountStatement
                selectedCustomer={selectedCustomer}
              />
            )
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ CustomerReducers, UserReducers }) => ({
  getCustomerByIdLoading: CustomerReducers.getCustomerByIdLoading,
  selectedCustomer: CustomerReducers.selectedCustomer,
  user: UserReducers.user,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomerById: (customerId, tenantId) => dispatch(CustomerActions.getCustomerById(customerId, tenantId)),
});

ViewCustomer.propTypes = {
  user: PropTypes.any,
  match: PropTypes.any,
  getCustomerById: PropTypes.func,
  selectedCustomer: PropTypes.any,
  getCustomerByIdLoading: PropTypes.bool,
  history: PropTypes.func,
  location: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewCustomer));
